import React, { useEffect, useState } from "react";
import {
  Container,
  Header,
  Form,
  Table,
  Checkbox,
  Grid,
  Button,
  Segment,
  Icon,
  Message,
  Label,
} from "semantic-ui-react";
import { connect } from "react-redux";
import PagarPrestamosHeader from "./PagarPrestamosHeader";
import {
  getCreditos,
  getCredito,
  getCuotas,
} from "../../../../app/store/actions/creditoActions";
import { getCuentasOperaciones } from "../../../../app/store/actions/cuentaActions";
import {
  procesarPagoCulqi,
  calcularItf,
  verificarDisponibilidadPago,
  procesarPagoCargoEnCuenta,
  validarProgramaEstado,
} from "../../../../app/store/actions/pagoActions";
import { Form as FinalForm, Field } from "react-final-form";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import PropTypes from "prop-types";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import {
  createOptionsPrestamos,
  createOptionsCronogramas,
  createOptionsCuentaPagos,
} from "../../../../app/util/optionsUtils";
import * as formatUtils from "../../../../app/util/formatUtils";
import { metodoPagoOptions } from "../../../../app/config/data/options";
import PagarPrestamosFooter from "./PagarPrestamosFooter";
import {
  PAY_FROM_DETAILS,
  KEY_PUBLIC_CULQI,
  CODIGO_METODO_PAGO_CULQI,
  CODIGO_METODO_PAGO_CUENTA_AHORROS,
  RESPONSE_MESSAGE_CODE_SUCCESS,
  MSG_VALIDACION_CLIENTE_FONDOS_PROPIOS_PROGRAMA_ESTADO,
} from "../../../../app/infrastructure/appConstants";
import PagarPrestamosResumenInfo from "./PagarPrestamosResumenInfo";
import PagarPrestamosResumenHeader from "./PagarPrestamosResumenHeader";
import { CulqiProvider, Culqi } from "react-culqi";
import { toast } from "react-toastify";
import { getCodigoMonedaIso } from "../../../../app/util/textCodeUtils";
import PagarPrestamosPagoExitoso from "./PagarPrestamosPagoExitoso";
import {
  MESSAGE_MONTO_COMTEMPLA_PENALIDAD,
  MESSAGE_PAGO_CUENTA_CARGO,
  TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL,
} from "../../../../app/util/messageUtils";
import {
  combineValidators,
  composeValidators,
  isRequired,
  isRequiredIf,
} from "revalidate";
import DisponibilidadOperacionesPagosMessage from "../../../../app/common/messages/DisponibilidadOperacionesPagosMessage";
import { resetScroll } from "../../../../app/util/JsUtils";
import ServicioNoDisponibleMessage from "../../../../app/common/messages/ServicioNoDisponibleMessage";
import CheckboxInput from "../../../../app/common/form/CheckboxInput";
import { isTrueConditional } from "../../../../app/util/revalidateUtils";
import CulqiBtn from "../../../../app/common/btn/CulqiBtn";

const mapState = (state) => ({
  creditos: state.creditoReducer.creditos,
  loadingCreditos: state.creditoReducer.loadingCreditos,
  currentUser: state.auth.currentUser,
  cuotas: state.creditoReducer.cuotas,
  loadingCuotas: state.creditoReducer.loadingCuotas,
  loadingCredito: state.creditoReducer.loadingCredito,
  credito: state.creditoReducer.credito,
  loadingProcesarPago: state.pagoReducer.loadingProcesarPago,
  loadingCalcularItf: state.pagoReducer.loadingCalcularItf,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  cuentasOperaciones: state.cuentaReducer.cuentasOperaciones,
  loadingCuentasOperaciones: state.cuentaReducer.loadingCuentasOperaciones,
  disponibilidadPago: state.pagoReducer.disponibilidadPago,
  loadingValidarProgramaEstado: state.pagoReducer.loadingValidarProgramaEstado,
  validacionProgramaEstado: state.pagoReducer.validacionProgramaEstado,
});

const actions = {
  getCreditos,
  getCredito,
  getCuotas,
  procesarPagoCulqi,
  procesarPagoCargoEnCuenta,
  calcularItf,
  verificarDisponibilidadPago,
  getCuentasOperaciones,
  validarProgramaEstado,
};

const PagarPrestamosPage = ({
  credito,
  creditos,
  loadingCreditos,
  getCreditos,
  getCredito,
  currentUser,
  getCuotas,
  cuotas,
  loadingCuotas,
  loadingCredito,
  procesarPagoCulqi,
  procesarPagoCargoEnCuenta,
  loadingProcesarPago,
  calcularItf,
  loadingCalcularItf,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  cuentasOperaciones,
  loadingCuentasOperaciones,
  getCuentasOperaciones,
  disponibilidadPago,
  loadingValidarProgramaEstado,
  validarProgramaEstado,
  validacionProgramaEstado,
}) => {
  //useState
  const [prestamoSeleccionado, setPrestamoSeleccionado] = useState(null);
  const [cronogramaSeleccionado, setCronogramaSeleccionado] = useState(null);
  const [metodoPagoSeleccionado, setMetodoPagoSeleccionado] = useState(null);
  const [cuotasSeleccionadas, setCuotasSeleccionadas] = useState([]);
  const [confirmarPago, setConfirmarPago] = useState(false);
  const [totalPagar, setTotalPagar] = useState(null);
  const [itf, setItf] = useState(null);
  const [montoCuotas, setMontoCuotas] = useState(null);
  const [totalPagarCulqi, setTotalPagarCulqi] = useState(null);
  const [monedaPrestamo, setMonedaPrestamo] = useState(null);
  const [codigoMonedaCulqi, setCodigoMonedaCulqi] = useState(null);
  const [mostrarMensajePagoExitoso, setMostrarMensajePagoExitoso] = useState(
    false
  );
  const [cuentaCargo, setCuentaCargo] = useState(null);
  const [saldoDisponibleCuentaCargo, setSaldoDisponibleCuentaCargo] = useState(
    null
  );
  const [codigoMonedaCuentaCargo, setCodigoMonedaCuentaCargo] = useState(null);
  const [
    indicadorAceptoFondoNoReactiva,
    setIndicadorAceptoFondoNoReactiva,
  ] = useState(false);

  //onChanges
  const onChangePrestamo = (value) => {
    if (value) {
      setPrestamoSeleccionado(value);
      setCuotasSeleccionadas([]);
      obtenerMonedaPrestamo(value);
      setCuentaCargo(null);
      const credito = creditos.find((cr) => cr.credito === value);
      if (credito && credito.indicadorMulticronograma === false) {
        setCronogramaSeleccionado(credito.cronogramas[0]);
      }
    }
  };
  const onChangeCronograma = (value) => {
    if (value) {
      setCronogramaSeleccionado(value);
      setCuotasSeleccionadas([]);
    }
  };
  //useEffect
  useEffect(() => {
    if (currentUser?.username) {
      getCreditos();
    }
  }, [getCreditos, currentUser]);

  useEffect(() => {
    if (prestamoSeleccionado) {
      getCredito({ credito: prestamoSeleccionado });
    }
  }, [getCredito, prestamoSeleccionado]);

  useEffect(() => {
    if (prestamoSeleccionado && cronogramaSeleccionado) {
      getCuotas({
        credito: prestamoSeleccionado,
        numeroCronograma: cronogramaSeleccionado,
      });
    }
  }, [getCuotas, prestamoSeleccionado, cronogramaSeleccionado]);

  useEffect(() => {
    if (currentUser?.username) {
      getCuentasOperaciones();
    }
  }, [getCuentasOperaciones, currentUser]);

  useEffect(() => {
    if (currentUser?.username) {
      verificarDisponibilidadPago();
    }
  }, [verificarDisponibilidadPago, currentUser]);

  useEffect(() => {
    if (currentUser?.username) {
      validarProgramaEstado();
    }
  }, [validarProgramaEstado, currentUser]);

  //business rules
  //Pretamo selecionado desde consulta de cuotas
  const preSeleccionarPrestamo = () => {
    if (localStorage.getItem(PAY_FROM_DETAILS) && credito) {
      localStorage.removeItem(PAY_FROM_DETAILS);
      setPrestamoSeleccionado(credito.credito);
      setCronogramaSeleccionado(Math.min(...credito.cronogramas));
      setMonedaPrestamo(credito.codigoMoneda);
    }
  };
  preSeleccionarPrestamo();
  //Metodo que devuelve si una cuota ha sido seleccionada
  const isCheckedCuota = (cuota) => {
    return cuotasSeleccionadas.includes(cuota);
  };
  //Obtiene indicador disabled cuota
  const isDisabledCuota = (cuota) => {
    //Si hay cuotas seleccionadas, y la cuota es menor a la maxima seleccionada se deshabilita
    if (
      cuotasSeleccionadas.length > 0 &&
      cuota < Math.max(...cuotasSeleccionadas)
    ) {
      return true;
    }
    //No se deshabilita la cuota maxima seleccionada
    else if (cuota === Math.max(...cuotasSeleccionadas)) {
      return false;
    } else {
      //Solo se habilita la cuota minima de las cuotas no seleccionadas
      //Lista de numeros de cuotas
      let listaCuotas = cuotas.map((t) => t.numero);
      //Se obtiene las cuotas que no han sido seleccionadas
      let listaCuotasNoSeleccionadas = [];
      listaCuotas.forEach((c) => {
        if (!cuotasSeleccionadas.includes(c)) {
          listaCuotasNoSeleccionadas.push(c);
        }
      });
      //Se obtiene la cuota minima
      let cuotaMinima = Math.min(...listaCuotasNoSeleccionadas);
      //Se deshabilita las cuotas que no son minima
      return cuota != cuotaMinima;
      // }
    }
  };

  //Permite agregar una cuota
  const addCuotaPagar = (cuota) => {
    let cuotasPagar = Array.from(cuotasSeleccionadas);
    if (cuotasSeleccionadas.filter((c) => c === cuota).length > 0) {
      cuotasPagar = cuotasSeleccionadas.filter((c) => c !== cuota);
    } else {
      cuotasPagar.push(cuota);
    }
    setCuotasSeleccionadas(cuotasPagar);
  };

  //Obtener lista de cuotas a pagar
  const obtenerListaCuotasPagar = () => {
    let cuotasPagar = [];
    cuotas.forEach((t) => {
      if (cuotasSeleccionadas.includes(t.numero)) cuotasPagar.push(t);
    });
    return cuotasPagar;
  };

  //Calcular total cuotas
  const calcularTotalCuotas = () => {
    const listaCuotasPagar = obtenerListaCuotasPagar();
    if (listaCuotasPagar.length > 0) {
      const listaMontosCuotas = listaCuotasPagar.map((t) => t.importe);
      const totalCuotas = listaMontosCuotas.reduce(
        (accumulator, importe) => accumulator + importe
      );
      return totalCuotas;
    }
  };
  //Calcular total a pagar
  const calcularTotalPagar = async (codigoMoneda) => {
    const totalCuotas = calcularTotalCuotas();
    const totalItf = await calcularItf({
      importe: totalCuotas,
      codigoMoneda: codigoMoneda,
      credito: prestamoSeleccionado,
    });
    obtenerMonedaPrestamo(prestamoSeleccionado);
    const total = totalCuotas + totalItf;
    setItf(totalItf);
    setMontoCuotas(totalCuotas);
    setTotalPagar(total);
    setTotalPagarCulqi((total * 100).toFixed(0));
  };

  //Obtener moneda prestamo
  const obtenerMonedaPrestamo = (prestamo) => {
    if (prestamo) {
      const codigoMoneda = creditos.filter((c) => c.credito === prestamo)[0]
        .codigoMoneda;
      setMonedaPrestamo(codigoMoneda);
      setCodigoMonedaCulqi(getCodigoMonedaIso(codigoMoneda));
      return codigoMoneda;
    }
  };

  //Metodo que permite reiniciar algunos valores cuando se regresa en el pago
  const handleAtras = () => {
    setConfirmarPago(false);
    setTotalPagar(null);
    setTotalPagarCulqi(null);
    setItf(null);
    setMontoCuotas(null);
  };

  //Metodo que permite hacer los calculos previo al pago
  const handleSiguiente = async (values) => {
    if (metodoPagoSeleccionado === CODIGO_METODO_PAGO_CUENTA_AHORROS) {
      if (
        monedaPrestamo === codigoMonedaCuentaCargo &&
        saldoDisponibleCuentaCargo < calcularTotalCuotas()
      ) {
        toast.error("La cuenta cargo no cuenta con el saldo disponible");
      } else {
        await preProcesarPago(values);
      }
    } else {
      await preProcesarPago(values);
    }
  };

  const preProcesarPago = async (values) => {
    //Verificando disponibilidad de pago
    const response = await verificarDisponibilidadPago();
    if (response && response.data && response.data.disponible === true) {
      setPrestamoSeleccionado(values.prestamo);
      setMetodoPagoSeleccionado(values.metodoPago);
      setCronogramaSeleccionado(values.numeroCronograma);
      await calcularTotalPagar(monedaPrestamo);
      setConfirmarPago(true);
      resetScroll();
    }
  };

  //Metodo que permite realizar pago desde una cuenta de ahorros
  const handlePagoDesdeCuentaAhorros = async () => {
    const numeroCronograma = obtenerNumeroCronograma();
    const request = {
      cuenta: cuentaCargo,
      importe: totalPagar,
      codigoMoneda: monedaPrestamo,
      credito: prestamoSeleccionado,
      numeroCronograma,
      aceptoFondoPropio: indicadorAceptoFondoNoReactiva,
    };
    const response = await procesarPagoCargoEnCuenta(request);
    if (response && response.code === RESPONSE_MESSAGE_CODE_SUCCESS) {
      setMostrarMensajePagoExitoso(true);
      resetScroll();
    }
  };

  //Options
  const creditosOptions = createOptionsPrestamos(creditos);
  let cronogramasOptions;
  if (credito) {
    cronogramasOptions = createOptionsCronogramas(credito.cronogramas);
  }

  const cuentasOptions = monedaPrestamo
    ? createOptionsCuentaPagos(cuentasOperaciones, monedaPrestamo)
    : [];

  //requests
  const createRequestPagoCulqi = (token) => {
    const numeroCronograma = obtenerNumeroCronograma();
    return {
      idToken: token.id,
      importe: totalPagar,
      codigoMoneda: monedaPrestamo,
      credito: prestamoSeleccionado,
      numeroCronograma,
      metadata: null,
      aceptoFondoPropio: indicadorAceptoFondoNoReactiva,
    };
  };

  const obtenerNumeroCronograma = () => {
    if (credito.indicadorMulticronograma === true) {
      return cronogramaSeleccionado;
    } else {
      return credito.cronogramas[0];
    }
  };
  //validates
  const validate = combineValidators({
    prestamo: composeValidators(
      isRequired({ message: "Debe seleccionar el préstamo a pagar." })
    )(),
    metodoPago: composeValidators(
      isRequired({ message: "Debe seleccionar el método de pago." })
    )(),
    cuentaCargo: composeValidators(
      isRequiredIf(
        (values) =>
          values && values.metodoPago === CODIGO_METODO_PAGO_CUENTA_AHORROS
      )({
        message: "Debe seleccionar la cuenta de cargo.",
      })
    )(),
    aceptoFondoNoReactiva: composeValidators(
      isRequiredIf(
        (values) =>
          validacionProgramaEstado && validacionProgramaEstado.isProgramaEstado
      )({
        message: MSG_VALIDACION_CLIENTE_FONDOS_PROPIOS_PROGRAMA_ESTADO,
      }),
      isTrueConditional(
        validacionProgramaEstado
          ? validacionProgramaEstado.isProgramaEstado
          : false
      )({
        message: MSG_VALIDACION_CLIENTE_FONDOS_PROPIOS_PROGRAMA_ESTADO,
      })
    )(),
  });
  //returns
  //loadings
  if (loadingCreditos)
    return <LoadingComponent content="Cargando préstamos..." />;
  if (loadingCredito)
    return <LoadingComponent content="Cargando información del préstamo..." />;
  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;
  if (loadingCuentasOperaciones)
    return <LoadingComponent content="Cargando cuentas operaciones.." />;
  if (loadingCuotas) return <LoadingComponent content="Cargando cuotas..." />;
  if (loadingCalcularItf)
    return <LoadingComponent content="Calculando total a pagar.." />;
  if (loadingProcesarPago)
    return <LoadingComponent content="Procesando pago.." />;
  if (loadingValidarProgramaEstado)
    return <LoadingComponent content="Validar programa estado.." />;

  //return
  if (mostrarMensajePagoExitoso) return <PagarPrestamosPagoExitoso />;
  if (creditos && creditos.length > 0 && creditosOptions.length === 0)
    return (
      <>
        <br />
        <Message negative>
          <Message.Header>
            Lamentamos informale que los siguientes tipos de créditos no están
            soportados:
          </Message.Header>
          <ul>
            <li>Confirming</li>
            <li>Caña</li>
          </ul>
        </Message>
      </>
    );

  const onToken = async (token) => {
    const requestMedioPagoCulqi = createRequestPagoCulqi(token);
    const response = await procesarPagoCulqi(requestMedioPagoCulqi);
    if (response && response.code === RESPONSE_MESSAGE_CODE_SUCCESS) {
      setMostrarMensajePagoExitoso(true);
      resetScroll();
    }
  };

  return (
    <Container className="containerPrincipal">
      <PagarPrestamosHeader />
      {!disponibilidadPago && <ServicioNoDisponibleMessage />}
      {confirmarPago === true && totalPagar && totalPagarCulqi ? (
        <>
          <DisponibilidadOperacionesPagosMessage />
          <PagarPrestamosResumenHeader metodoPago={metodoPagoSeleccionado} />
          <Segment>
            <PagarPrestamosResumenInfo
              numeroPrestamo={prestamoSeleccionado}
              montoCuotas={montoCuotas}
              itf={itf}
              totalPagar={totalPagar}
              codigoMonedaPrestamo={monedaPrestamo}
              metodoPago={metodoPagoSeleccionado}
              cargoCuenta={cuentaCargo}
            />
            <Grid>
              <Grid.Row>
                <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
                  <Button
                    fluid
                    content="Atrás"
                    onClick={() => handleAtras()}
                    color="blue"
                    size="large"
                  />
                </Grid.Column>
                <Grid.Column
                  computer={8}
                  largeScreen={8}
                  mobile={2}
                  tablet={4}
                />
                <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
                  {metodoPagoSeleccionado === CODIGO_METODO_PAGO_CULQI ? (
                    <CulqiBtn
                      amount={totalPagarCulqi}
                      currency={codigoMonedaCulqi}
                      title="Pagar préstamo"
                      event={onToken}
                    />
                  ) : metodoPagoSeleccionado ===
                    CODIGO_METODO_PAGO_CUENTA_AHORROS ? (
                    <>
                      <Button
                        content="Confirmar"
                        fluid
                        onClick={handlePagoDesdeCuentaAhorros}
                        color="yellow"
                        size="large"
                      />
                    </>
                  ) : (
                    <Header
                      as="h4"
                      content="Método de pago no soportado"
                      color="grey"
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </>
      ) : (
        <FinalForm
          onSubmit={handleSiguiente}
          initialValues={{
            prestamo: prestamoSeleccionado,
            metodoPago: metodoPagoSeleccionado,
            numeroCronograma: cronogramaSeleccionado,
            cuentaCargo: cuentaCargo,
            aceptoFondoNoReactiva: indicadorAceptoFondoNoReactiva,
          }}
          validate={validate}
          render={({ handleSubmit, submitting, values, invalid }) => (
            <Form onSubmit={handleSubmit} error style={{ marginTop: "2.5em" }}>
              <Header
                as="h4"
                color="blue"
                content="Selecciona tu préstamo a pagar"
              />
              <Field
                name="prestamo"
                component={SelectedInput}
                placeholder="Selecciona un préstamo"
                options={creditosOptions}
                handleOnChange={onChangePrestamo}
                disabled={!disponibilidadPago}
              />
              {credito &&
                credito.indicadorMulticronograma === true &&
                prestamoSeleccionado && (
                  <>
                    <Header
                      as="h4"
                      color="blue"
                      content="Selecciona tu cronograma a pagar"
                    />
                    <Field
                      name="numeroCronograma"
                      component={SelectedInput}
                      placeholder="Selecciona un cronograma"
                      options={cronogramasOptions}
                      handleOnChange={onChangeCronograma}
                    />
                  </>
                )}
              {values.prestamo &&
                cuotas &&
                cuotas.length > 0 &&
                cronogramaSeleccionado && (
                  <>
                    <Header
                      as="h4"
                      color="blue"
                      content="Selecciona tu(s) cuota(s) a pagar"
                    />
                    <Table compact celled definition>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell />
                          <Table.HeaderCell>Nro Cuota</Table.HeaderCell>
                          <Table.HeaderCell>Monto</Table.HeaderCell>
                          <Table.HeaderCell>Días de atraso</Table.HeaderCell>
                          <Table.HeaderCell>Vencimiento</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {cuotas &&
                          cuotas.map((cuota, index) => (
                            <Table.Row
                              key={index}
                              negative={cuota.alertaCuotaVencida === true}
                            >
                              <Table.Cell collapsing>
                                <Checkbox
                                  slider
                                  checked={isCheckedCuota(cuota.numero)}
                                  disabled={isDisabledCuota(cuota.numero)}
                                  onChange={() => addCuotaPagar(cuota.numero)}
                                />
                              </Table.Cell>
                              <Table.Cell>{cuota.numero}</Table.Cell>
                              <Table.Cell
                                onClick={() => {
                                  if (cuota.alertaCuotaVencida === true)
                                    toast.info(
                                      MESSAGE_MONTO_COMTEMPLA_PENALIDAD
                                    );
                                }}
                                negative={cuota.alertaCuotaVencida === true}
                                style={
                                  cuota.alertaCuotaVencida === true
                                    ? { cursor: "pointer" }
                                    : {}
                                }
                              >
                                {cuota.alertaCuotaVencida === true ? (
                                  <>
                                    {`${
                                      cuota.nombreMoneda
                                    } ${formatUtils.formatMoney(
                                      cuota.importe
                                    )}`}
                                    <Icon name="warning circle" />
                                  </>
                                ) : (
                                  `${
                                    cuota.nombreMoneda
                                  } ${formatUtils.formatMoney(cuota.importe)}`
                                )}
                              </Table.Cell>
                              <Table.Cell>{cuota.diasVencidos}</Table.Cell>
                              <Table.Cell>
                                {formatUtils.dateFormat(cuota.fechaVencimiento)}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                      </Table.Body>
                    </Table>

                    {validacionProgramaEstado &&
                      validacionProgramaEstado.isProgramaEstado && (
                        <>
                          <br />
                          <Field
                            name="aceptoFondoNoReactiva"
                            component={CheckboxInput}
                            type="checkbox"
                            label={validacionProgramaEstado.mensaje}
                            handleOnChange={(value) => {
                              setIndicadorAceptoFondoNoReactiva(value);
                            }}
                            checked={indicadorAceptoFondoNoReactiva}
                          />
                        </>
                      )}
                    <Header
                      as="h4"
                      color="blue"
                      content="Selecciona tu método de pago"
                    />
                    <Field
                      name="metodoPago"
                      component={SelectedInput}
                      placeholder="Selecciona un método de pago"
                      options={metodoPagoOptions}
                      handleOnChange={(value) => {
                        setMetodoPagoSeleccionado(value);
                        setCuentaCargo(null);
                      }}
                    />
                    {metodoPagoSeleccionado ===
                      CODIGO_METODO_PAGO_CUENTA_AHORROS && (
                      <>
                        <Header
                          as="h4"
                          color="blue"
                          content="Selecciona la cuenta de cargo"
                        />
                        <Field
                          name="cuentaCargo"
                          component={SelectedInput}
                          placeholder="Selecciona la cuenta de cargo"
                          options={cuentasOptions}
                          handleOnChange={(value) => {
                            setCuentaCargo(value);
                            if (
                              value &&
                              cuentasOperaciones &&
                              cuentasOperaciones.length > 0
                            ) {
                              const cuenta = cuentasOperaciones.filter(
                                (c) => c.numeroCuenta === value
                              )[0];
                              setSaldoDisponibleCuentaCargo(
                                cuenta.saldoDisponible
                              );
                              setCodigoMonedaCuentaCargo(cuenta.codigoMoneda);
                            }
                          }}
                        />
                        <Label color="blue" tag size="medium">
                          {MESSAGE_PAGO_CUENTA_CARGO}
                        </Label>
                        <br />
                        {monedaPrestamo &&
                          codigoMonedaCuentaCargo &&
                          monedaPrestamo !== codigoMonedaCuentaCargo && (
                            <>
                              <br />
                              <Label color="blue" tag size="medium">
                                {TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL}
                              </Label>
                              <br />
                            </>
                          )}
                      </>
                    )}
                    <br />
                    <PagarPrestamosFooter
                      disabled={invalid || cuotasSeleccionadas.length === 0}
                      submitting={submitting}
                    />
                  </>
                )}

              {/* <pre>{JSON.stringify(values)}</pre> */}
            </Form>
          )}
        />
      )}
    </Container>
  );
};

PagarPrestamosPage.propTypes = {
  creditos: PropTypes.array.isRequired,
  loadingCreditos: PropTypes.bool.isRequired,
  getCreditos: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  cuentasOperaciones: PropTypes.array.isRequired,
  loadingCuentasOperaciones: PropTypes.bool.isRequired,
  getCuentasOperaciones: PropTypes.func.isRequired,
  procesarPagoCargoEnCuenta: PropTypes.func.isRequired,
  disponibilidadPago: PropTypes.bool.isRequired,
  loadingValidarProgramaEstado: PropTypes.bool.isRequired,
  validarProgramaEstado: PropTypes.func.isRequired,
};
export default connect(mapState, actions)(PagarPrestamosPage);
